import classnames from 'classnames'
import { FunctionalComponent } from 'preact'
import { generateCssClassName } from './generateCssClassName'

export interface ConfigurationSettingProps {
  label: string
}

const ConfigurationSetting: FunctionalComponent<ConfigurationSettingProps> = ({ label, children }) => {
  return (
    <div className={classnames('theme-configuration-generic-setting', generateCssClassName(label))}>
      <div className='theme-configuration-generic-setting_name'>{label}</div>
      <div className='theme-configuration-generic-setting_configuration'>{children}</div>
    </div>
  )
}

export default ConfigurationSetting
